@if (isLoading$ | async) {
    <div class="d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <ng-content></ng-content>
}
